/** Hyperliquid market-order slippage presets (percent → bps). */
export const HL_SLIPPAGE_PRESETS = [
  { id: '1', label: '1%', bps: 100 },
  { id: '2', label: '2%', bps: 200 },
  { id: '3', label: '3%', bps: 300 },
  { id: '5', label: '5%', bps: 500 },
  { id: 'none', label: 'No max', bps: 10000 },
];

export const HL_SLIPPAGE_DEFAULT_MODE = '2';

/** Resolve UI slippage mode + optional custom % to bps for API. Returns null if custom is invalid. */
export function resolveHlSlippageBps(mode, customPct) {
  if (mode === 'custom') {
    const pct = parseFloat(customPct);
    if (!Number.isFinite(pct) || pct <= 0) return null;
    return Math.min(10000, Math.round(pct * 100));
  }
  if (mode === 'none') return 10000;
  const preset = HL_SLIPPAGE_PRESETS.find((p) => p.id === mode);
  return preset?.bps ?? 200;
}

export function formatHlSlippageLabel(bps) {
  if (bps == null) return '—';
  if (bps >= 10000) return 'No max';
  const pct = bps / 100;
  return pct % 1 === 0 ? `${pct}%` : `${pct.toFixed(2)}%`;
}
